import { ActionBarButton, ActionBarItemGroup } from "../core/action-bar/item";
import SyncModal from "../core/modals/sync/index";


/** Demo button for accessing job list. */
export class JobListButton extends ActionBarButton
{
    public title = 'Order list';
    public iconClassList = 'im im-paste';
    public hash = '#/orders/';

    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Order list');
        return super.beforeRender();
    }
}

/** Demo button for accessing job task list. */
export class JobTaskListButton extends ActionBarButton
{
    public title = 'Order items';
    public iconClassList = 'im im-list-numbered';
    public hash = '#/order-items/';
    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Order items');
        return super.beforeRender();
    }
}

export class TestDataBindsButton extends ActionBarButton
{
    public title = 'Data bind test';
    public iconClassList = 'im im-lab';
    public hash = '#/test';
}

export class TestChainButton extends ActionBarButton
{
    public title = 'View chain test';
    public iconClassList = 'im im-link';
    public hash = '#/test-chain';
}

export class TestDynamicallyAddedRemovedButton extends ActionBarButton
{
    public title = 'View chain test';
    public iconClassList = 'im im-bug';

    public onClick(e: MouseEvent): void
    {
        this.app.toasts.show(`Hello, ${Math.random()}!`);
    }
}